import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TestimonialsPanelComponent } from './testimonials-panel.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { TestimonialsPanelInfoModule } from './components/testimonials-panel-info/testimonials-panel-info.module';

@NgModule({
  declarations: [TestimonialsPanelComponent],
  exports: [TestimonialsPanelComponent],
  imports: [
    CommonModule,
    SharedModule,
    TestimonialsPanelInfoModule
  ],
})
export class TestimonialsPanelModule { }
